import moment from 'moment';
import { dateFormatMap, dateTimeFormatMap } from './config';
import { langTextRules } from './langText';

export function langT(TextA: any, key: string, option?: any) {
    if (!TextA || !key) {
        return null;
    }
    let value = TextA[key] || '';
    if (!option) {
        return value || key;
    }
    for (const keyB in option) {
        const valB = option[keyB] || '';
        value = value.replace(`{${keyB}}`, valB);
    }
    return value;
}
export const FormatMoney = (key: number | string, splitStr = ',') => {
    let value;
    if (key || key === 0) {
        const tmpKey = key.toString();
        const reg = /(\d)(?=(\d{3})+$)/g;
        value = tmpKey.replace(reg, `$1${splitStr}`);
    }
    return value;
};

export function injectNotesItem(coupon: any, locale: string) {
    const TextA = langTextRules[locale] || langTextRules['us'];
    const noteList: string[] = [langT(TextA, 'site_rules'), langT(TextA, 'order_rule')];
    // 不找零
    if (coupon?.prerequisite !== 'PRICES' && coupon?.discountType === 'fixed_amount') {
        noteList.push(langT(TextA, 'purchas_rule'));
    }
    if (coupon?.prerequisite === 'PRICES' && coupon?.discountType === 'fixed_amount') {
        const couponPrice = parseInt(coupon?.amount);
        const priceRange = parseInt(coupon.prerequisiteRange);
        if (priceRange < couponPrice) {
            noteList.push(langT(TextA, 'purchas_rule'));
        }
    }
    if (coupon?.goodId) noteList.push(langT(TextA, 'product_rules', { product: coupon?.goodTitle || '' }));

    // 最低金额
    if (coupon?.prerequisite === 'PRICES') {
        const price = parseInt(coupon.prerequisiteRange);
        const currencySymbol = coupon?.currencySymbol || '';
        const prerequisiteRange = langT(TextA, 'minimum_price', { price: currencySymbol + FormatMoney(price) });
        noteList.push(prerequisiteRange);
    }

    // 最低数量
    if (coupon?.prerequisite === 'QUANTITY') {
        const num = parseInt(coupon.prerequisiteRange);
        const prerequisiteRange = langT(TextA, 'minimum_num', { num });
        noteList.push(prerequisiteRange);
    }

    // 过期天数
    const limitDay = Math.floor((coupon?.expiredDay || 0) / 60 / 24);
    if (coupon?.expiredFlag && coupon?.expiredType === 'DAY') {
        noteList.push(langT(TextA, 'days_rules', { days: limitDay }));
    }
    // 时间 for 福利中心
    if (coupon?.couponId && coupon?.endTime && coupon?.expiredType === 'TIME') {
        const formater = dateTimeFormatMap[locale as string] || dateTimeFormatMap['us'];
        const startTime = moment(Number(coupon?.startTime)).format(formater);
        const endTime = moment(Number(coupon?.endTime)).format(formater);
        noteList.push(langT(TextA, 'days_rules2', { data: `${startTime}-${endTime}` }));
    }

    // 时间 for 优惠券
    if (coupon?.coupon && coupon?.endTime) {
        const formater = dateTimeFormatMap[locale as string] || dateTimeFormatMap['us'];
        const startTime = moment(Number(coupon?.startTime)).format(formater);
        const endTime = moment(Number(coupon?.endTime)).format(formater);
        noteList.push(langT(TextA, 'days_rules2', { data: `${startTime}-${endTime}` }));
    }

    // 时间 for 优惠券规则
    if (!(coupon?.coupon || coupon?.couponId) && coupon?.expiredFlag && coupon?.validEndTime && coupon?.expiredType === 'TIME') {
        const formater = dateTimeFormatMap[locale as string] || dateTimeFormatMap['us'];
        const startTime = moment(Number(coupon?.validStartTime)).format(formater);
        const endTime = moment(Number(coupon?.validEndTime)).format(formater);
        noteList.push(langT(TextA, 'days_rules2', { data: `${startTime}-${endTime}` }));
    }

    // campaign限时型时间
    if (!coupon?.discountId && coupon?.campaignStartTime && coupon?.campaignEndTime) {
        const formater = dateFormatMap[locale as string] || dateFormatMap['us'];
        const startTime = moment(Number(coupon?.campaignStartTime)).format(formater);
        const endTime = moment(Number(coupon?.campaignEndTime)).format(formater);
        noteList.push(langT(TextA, 'campaign_time_limit_text', { startTime, endTime }));
    }
    // 临时新增规则 只针对这一个优惠券
    if (coupon?.discountId && coupon?.discountId === '1698949120957939713') {
        noteList.push('*단순 개봉 제품');
    }
    if (coupon?.extRuleDesc) {
        noteList.push(coupon?.extRuleDesc);
    }
    return noteList;
}

export default function injectNotesNew(coupon: any[], locale: string) {
    const TextA = langTextRules[locale] || langTextRules['us'];
    return coupon?.map((coupon: any) => {
        const noteList: string[] = [langT(TextA, 'site_rules'), langT(TextA, 'order_rule')];
        // 不找零
        if (coupon?.prerequisite !== 'PRICES' && coupon?.discountType === 'fixed_amount') {
            noteList.push(langT(TextA, 'purchas_rule'));
        }
        if (coupon?.prerequisite === 'PRICES' && coupon?.discountType === 'fixed_amount') {
            const couponPrice = parseInt(coupon?.amount);
            const priceRange = parseInt(coupon.prerequisiteRange);
            if (priceRange < couponPrice) {
                noteList.push(langT(TextA, 'purchas_rule'));
            }
        }
        if (coupon?.goodId) noteList.push(langT(TextA, 'product_rules', { product: coupon?.goodTitle || '' }));

        // 最低金额
        if (coupon?.prerequisite === 'PRICES') {
            const price = parseInt(coupon.prerequisiteRange);
            const currencySymbol = coupon?.currencySymbol || '';
            const prerequisiteRange = langT(TextA, 'minimum_price', { price: currencySymbol + FormatMoney(price) });
            noteList.push(prerequisiteRange);
        }

        // 最低数量
        if (coupon?.prerequisite === 'QUANTITY') {
            const num = parseInt(coupon.prerequisiteRange);
            const prerequisiteRange = langT(TextA, 'minimum_num', { num });
            noteList.push(prerequisiteRange);
        }

        // 过期天数
        const limitDay = Math.floor((coupon?.expiredDay || 0) / 60 / 24);
        if (coupon?.expiredFlag && coupon?.expiredType === 'DAY') {
            noteList.push(langT(TextA, 'days_rules', { days: limitDay }));
        }
        // 时间 for 福利中心
        if (coupon?.couponId && coupon?.endTime && coupon?.expiredType === 'TIME') {
            const formater = dateTimeFormatMap[locale as string] || dateTimeFormatMap['us'];
            const startTime = moment(Number(coupon?.startTime)).format(formater);
            const endTime = moment(Number(coupon?.endTime)).format(formater);
            noteList.push(langT(TextA, 'days_rules2', { data: `${startTime}-${endTime}` }));
        }

        // 时间 for 优惠券
        if (coupon?.coupon && coupon?.endTime) {
            const formater = dateTimeFormatMap[locale as string] || dateTimeFormatMap['us'];
            const startTime = moment(Number(coupon?.startTime)).format(formater);
            const endTime = moment(Number(coupon?.endTime)).format(formater);
            noteList.push(langT(TextA, 'days_rules2', { data: `${startTime}-${endTime}` }));
        }

        // 时间 for 优惠券规则
        if (!(coupon?.coupon || coupon?.couponId) && coupon?.expiredFlag && coupon?.validEndTime && coupon?.expiredType === 'TIME') {
            const formater = dateTimeFormatMap[locale as string] || dateTimeFormatMap['us'];
            const startTime = moment(Number(coupon?.validStartTime)).format(formater);
            const endTime = moment(Number(coupon?.validEndTime)).format(formater);
            noteList.push(langT(TextA, 'days_rules2', { data: `${startTime}-${endTime}` }));
        }

        // campaign限时型时间
        if (!coupon?.discountId && coupon?.campaignStartTime && coupon?.campaignEndTime) {
            const formater = dateFormatMap[locale as string] || dateFormatMap['us'];
            const startTime = moment(Number(coupon?.campaignStartTime)).format(formater);
            const endTime = moment(Number(coupon?.campaignEndTime)).format(formater);
            noteList.push(langT(TextA, 'campaign_time_limit_text', { startTime, endTime }));
        }
        // 临时新增规则 只针对这一个优惠券
        if (coupon?.discountId && coupon?.discountId === '1698949120957939713') {
            noteList.push('*단순 개봉 제품');
        }
        if (coupon?.extRuleDesc) {
            noteList.push(coupon?.extRuleDesc);
        }
        return { ...coupon, showMore: false, noteList };
    });
}
